import BaseFormItem from "../BaseFormItem";
import React from "react";
import Control from "lib/common/descriptorcontrols/DecimalField/label";

export class DecimalFieldlabel extends BaseFormItem {
    render() {
        const {activeRecord, descriptor} = this.props;
        return <Control {...this.getPlumbingProps()}
                        value={activeRecord.get(descriptor.key)}
                        enabled={activeRecord.isFieldEnabled(descriptor.key)}
        />;
    }
}

export default DecimalFieldlabel;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/dataentryform/formitems/DecimalField/label.js